import React from "react";
import { withStyles } from "@material-ui/core/styles"
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Button, Grid, Checkbox, FormControlLabel, CircularProgress, TextField, Icon } from "@material-ui/core";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { createRole, setTableContentLoading } from "app/redux/actions/RoleActions";


const styles = theme => ({
    root: {
        backgroundColor: theme.palette.primary.main,
        margin: 0,
        padding: theme.spacing(2),
        color: "white",
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "white"
    }
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="h6" className="delete-h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="Close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(1)
    }
}))(MuiDialogActions);

class CreateRole extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            role: {
                RoleId: "",
                Name: "",
                Permissions: []
            }
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);//
        this.checkboxHandleChange = this.checkboxHandleChange.bind(this);

    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleSave = event => {
        this.handleSubmit(this.state.role)
    }

    handleSubmit = value => {
        this.props.createRole(value).then(data => {
            if (data) {
                this.handleClose();
                this.setState({
                    role: {
                        RoleId: "",
                        Name: "",
                        Permissions: []
                    }
                }, () => {
                    this.props.setTableContentLoading(true);
                    setTimeout(() => {
                        this.props.setTableContentLoading(false);
                    }, 700);
                });
            }
        });
    };

    handleChange = event => {
        event.persist();
        let roleCopy = this.state.role;
        for (let key in roleCopy) {
            if (key === event.target.name) {
                roleCopy[`${key}`] = event.target.value
            }
        }
        this.setState({ role: roleCopy });
    };

    checkboxHandleChange = (event, permission) => {
        let result = [];
        event.persist();
        let roleCopy = this.state.role;
        let permissionsCopy = roleCopy["Permissions"];
        if (permissionsCopy.length == 0) { // Si l'objet rôle ne contient aucune permission on l'ajoute simplement
            if (event.target.checked) { // on s'assure que c'est un check
                result.push(permission); // On ajoute la permission
            }
        }
        else if (permissionsCopy.length > 0) { // Sinon si le rôle courant contient déjà au moins une permission
            if (event.target.checked) { // On vérifie si c'est un check
                result = permissionsCopy; // On copie les valeurs existantes dans le tableau de resultat vide
                result.push(permission); // puis on ajoute la nouvelle valeur checked
            }
            else { // Sinon (ça veut dire que c'est un unchecked) 
                permissionsCopy.forEach(element => { // On loop les permissions courantes dans le rôle
                    if (element.Name !== event.target.name) { // on s'assure que chaque élément est différent de la valeur unchecked
                        result.push(element); // On copie chaque élément est différent de la valeur unchecked dans le tableau de resultat vide
                    }
                });
            }
        }
        roleCopy["Permissions"] = result; // On met à jour la liste de permissions de l'objet copie du rôle
        this.setState({ role: roleCopy });// On met à jour le rôle dans le state
    };

    render() {
        let { RoleId, Name, Permissions } = this.state.role;
        return (
            <div>
                <IconButton
                    // variant="outlined"
                    color="primary"
                    className="btn-primary"
                    onClick={this.handleClickOpen}
                    title="Ajouter"
                >
                    <Icon>add</Icon>
                </IconButton>
                <Dialog
                    disableBackdropClick
                    onClose={this.handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={this.state.open}
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                        Création d'un nouveau role
                    </DialogTitle>
                    <DialogContent dividers>
                        <ValidatorForm
                            ref="form"
                            onSubmit={this.handleSubmit}
                            onError={errors => null}
                            style={{ marginTop: "10px" }}
                        >
                            <Grid container spacing={12}>
                                <Grid item xs={12}>
                                    <TextValidator
                                        className="mb-16 w-100"
                                        label="Nom du rôle"
                                        onChange={this.handleChange}
                                        type="text"
                                        name="Name"
                                        value={Name}
                                        validators={["required"]}
                                        errorMessages={["Le nom du rôle est recquis"]}
                                        fullWidth
                                    />
                                </Grid>
                                {this.props.permissionList.map((item, index) => (
                                    item.Name != "AllowedToManageAccount" && (
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={<Checkbox name={item.Name} onChange={(e) => this.checkboxHandleChange(e, item)} value={item.PermissionId} />}
                                                label={item.ShortDescription}
                                            />
                                        </Grid>
                                    )))}

                            </Grid>
                        </ValidatorForm>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSave} color="secondary" variant="contained" disabled={this.props.storeRole.submitting}>
                            Soumettre {this.props.storeRole.submitting ? <CircularProgress size={20} /> : <span></span>}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

//export default CreateEntityDialog;

const mapStateToProps = state => ({
    createRole: PropTypes.func.isRequired,
    setTableContentLoading: PropTypes.func.isRequired,
    storeRole: state.role,
});
export default (
    withRouter(connect(mapStateToProps, { createRole, setTableContentLoading })(CreateRole))
);